import { createRouter, createWebHistory } from "vue-router";
import HomePage from "../views/HomePage.vue";
import SearchResultsPage from "../views/SearchResultsPage.vue";
import EventDetailsPage from "@/views/EventDetailsPage.vue";
// import TicketReview from "@/views/TicketReview.vue";
import ContactUs from "@/views/ContactUs.vue";
import PrivacyPolicy from "@/views/PrivacyPolicy.vue";
import DiscoverComponent from "@/views/DiscoverComponent.vue";
import OrganizerPublicView from "@/views/organizer/OrganizerPublicView.vue";
import UnsubscribeView from "@/views/unsubscribe.vue";
import store from "@/store";
const isDev = process.env.VUE_APP_DEV === "True";
const routes = [
	{
		path: "/",
		name: "Home",
		component: isDev ? OrganizerPublicView : HomePage,
		meta: { area: isDev ? "tenant" : "normal" },
	},
	{
		path: "/",
		name: "tenant-public",
		component: OrganizerPublicView,
		meta: { area: "tenant" },
	},
	{
		path: "/search-results",
		name: "search-results",
		component: SearchResultsPage,
		props: (route) => ({
			location: route.query.location,
			searchResults: route.state?.searchResults || [],
		}),
	},
	{
		path: "/event/:id",
		name: "event-details",
		component: EventDetailsPage,
	},
	{
		path: "/contact",
		name: "contact",
		component: ContactUs,
	},
	{
		path: "/privacy-policy",
		name: "privacy-policy",
		component: PrivacyPolicy,
	},
	{
		path: "/discover",
		name: "discover",
		component: DiscoverComponent,
	},
	{
		path: "/unsubscribe",
		name: "Unsbuscribe", // Route name
		component: UnsubscribeView,
	},

	// Fallback route
	{
		path: "/:pathMatch(.*)*",
		redirect: "/",
	},
];

const router = createRouter({
	history: createWebHistory(),
	routes,
});
// route to correct root based on subdomain presence
router.beforeEach(async (to, from, next) => {
	await store.dispatch("tenant/init"); // idempotent
	if (isDev) {
		// skip redirection in dev
		return next();
	}
	const hasSub = !!store.getters["tenant/tenantSub"];
	const isNormal = to.meta?.area === "normal";
	const isTenant = to.meta?.area === "tenant";

	if (hasSub && isNormal) return next({ name: "tenant-public" });
	if (!hasSub && isTenant) return next({ name: "Home" });
	next();
});

export default router;
